import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Sparkles, ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const categoryColors = {
  world: '#4ECDC4', politics: '#FF6B6B', economy: '#FFE66D',
  tech: '#9B59B6', science: '#3498DB', sports: '#2ECC71', celebrity: '#E91E63',
};

const RecommendedSection = () => {
  const { getAuthHeader, user } = useAuth();
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/recommended?limit=6`, { headers: user ? getAuthHeader() : {} })
      .then((res) => setItems(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading || items.length === 0) return null;

  return (
    <div className="mb-12" data-testid="recommended-section">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-6 h-6 text-[#FF6B6B]" strokeWidth={2.5} />
        <h2 className="text-2xl md:text-3xl font-bold dark:text-white" style={{ fontFamily: 'Merriweather, serif' }}>
          {t('recommended.title')}
        </h2>
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-5">{t('recommended.subtitle')}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((news) => (
          <a
            key={news.id}
            href={news.source_url || '#'}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`recommended-card-${news.id}`}
            className="group block bg-white dark:bg-[#2D2A26] border-2 border-black dark:border-white rounded-xl overflow-hidden hard-shadow-hover transition-transform hover:-translate-y-1"
          >
            <div className="relative h-36 overflow-hidden">
              <img
                src={news.image_url || `https://picsum.photos/600/300?random=${news.id}`}
                alt={news.title}
                className="w-full h-full object-cover"
                onError={(e) => { e.target.src = `https://picsum.photos/600/300?random=${news.id}`; }}
              />
              <span
                className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full border border-black text-black"
                style={{ backgroundColor: categoryColors[news.category] || '#4ECDC4' }}
              >
                {news.category}
              </span>
            </div>
            <div className="p-4">
              <p className="font-bold text-sm leading-snug dark:text-white line-clamp-3" style={{ fontFamily: 'Merriweather, serif' }}>
                "{news.humorous_summary}"
              </p>
              <div className="flex items-center justify-between mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
                <span className="text-xs text-gray-500 dark:text-gray-400 font-medium truncate">{news.source}</span>
                <ExternalLink className="w-3.5 h-3.5 text-[#4ECDC4] flex-shrink-0" strokeWidth={2.5} />
              </div>
            </div>
          </a>
        ))}
      </div>
      <div className="text-center mt-4">
        <Link to="/leaderboard" className="text-sm font-bold text-[#FF6B6B] hover:underline">
          {t('leaderboard.title')} →
        </Link>
      </div>
    </div>
  );
};

export default RecommendedSection;
